import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import moment from 'moment';
import React from 'react';

import { getUserWithFullNameAndEmaiDisplayValue } from '@/src/components/project/Inbox2/models/EmailEntry';

const PreviousMessage = ({ previousMessage }) => {
  const messageContent = parse(DOMPurify.sanitize(previousMessage.html));

  const dateAdded = moment(previousMessage.dateAdded).format('DD-MMM YYYY hh:mm A');
  const fromNames = previousMessage.from
    .map((f) => getUserWithFullNameAndEmaiDisplayValue(f))
    .join(',');

  return (
    <React.Fragment>
      <div
        className={'container--ellipsisContent'}
        style={{
          color: '#414A4F',
          fontSize: '14px',
          borderLeft: '1px solid #eeeeee',
          padding: '10px',
        }}
      >
        <span> On </span>
        <span> {dateAdded} </span>
        <span> {fromNames} </span>
        <span> wrote: </span>
        <div
          className={'container--messageThread'}
          style={{
            whiteSpace: 'normal',
            marginTop: '10px',
            marginLeft: '5px',
            color: '#414A4F',
          }}
        >
          {messageContent}
        </div>
      </div>
    </React.Fragment>
  );
};

export default PreviousMessage;
